export default __webpack_public_path__ + "static/media/dieppe16.bc408a34.jpg";